export default __webpack_public_path__ + "static/media/Montserrat-ThinItalic.3096cb47.ttf";